import { ActionHint, ShippableEventId } from '@ppwr/poker'

export const StepFunctionTags = {
  StreetFinished: 'StreetFinished',
  Showdown: 'Showdown',
  HandWinners: 'HandWinners',
  NewHand: 'NewHand',
  Reset: 'Reset',
  DoNoAction: 'DoNoAction',
  DoAction: 'DoAction',
  CalculateNextBlinds: 'CalculateNextBlinds',
  StartGame: 'StartGame',
  RegistrationWindow: 'RegistrationWindow',
  StillOpenWindow: 'StillOpenWindow',
  RotateNotifications: 'RotateNotifications'
} as const
export type StepFunctionTag = keyof typeof StepFunctionTags
export type SleepStepFunctionTag = Exclude<
  StepFunctionTag,
  'DoNoAction' | 'DoAction' | 'CalculateNextBlinds' | 'RegistrationWindow' | 'StillOpenWindow' | 'RotateNotifications'
>

interface StepFunctionBasePayload {
  kind: StepFunctionTag
  channelName: string
  fromBoardState?: string
  eventsToBroadcastAfterSleepIds?: ShippableEventId[]
}

export interface PausableStepFunctionInput extends StepFunctionBasePayload {
  restartAfterSeconds: number
  kind: 'StreetFinished' | 'Showdown' | 'HandWinners' | 'NewHand' | 'Reset' | 'StartGame'
  resumedByTeacher?: boolean
}
export interface DoNoActionStepFunctionInput extends StepFunctionBasePayload {
  kind: 'DoNoAction'
  restartAfterSeconds: number
  playerId: string
}

export interface DoActionStepFunctionInput extends StepFunctionBasePayload {
  kind: 'DoAction'
  restartAfterSeconds: number
  playerId: string
  action?: ActionHint
}

export interface CalculateNextBlindsStepFunctionInput extends StepFunctionBasePayload {
  kind: 'CalculateNextBlinds'
  restartAfterSeconds: number
  blindLevel: number
}

export interface RegistrationWindowStepFunctionInput extends StepFunctionBasePayload {
  kind: 'RegistrationWindow'
  restartAfterSeconds: number
}

export interface StartGameStepFunctionInput extends StepFunctionBasePayload {
  kind: 'StartGame'
  restartAfterSeconds: number
}

export interface StillOpenWindowStepFunctionInput extends StepFunctionBasePayload {
  kind: 'StillOpenWindow'
  restartAfterSeconds: number
}

export interface RotateNotificationsStepFunctionInput extends StepFunctionBasePayload {
  kind: 'RotateNotifications'
  restartAfterSeconds: number
}

export type StepFunctionPayloads =
  | ({
      kind: 'StreetFinished' | 'Showdown' | 'HandWinners' | 'NewHand' | 'Reset'
    } & PausableStepFunctionInput)
  | ({
      kind: 'DoNoAction'
    } & DoNoActionStepFunctionInput)
  | ({
      kind: 'DoAction'
    } & DoActionStepFunctionInput)
  | ({
      kind: 'CalculateNextBlinds'
    } & CalculateNextBlindsStepFunctionInput)
  | ({
      kind: 'RegistrationWindow'
    } & RegistrationWindowStepFunctionInput)
  | ({
      kind: 'StartGame'
    } & StartGameStepFunctionInput)
  | ({
      kind: 'StillOpenWindow'
    } & StillOpenWindowStepFunctionInput)
  | ({
      kind: 'RotateNotifications'
    } & RotateNotificationsStepFunctionInput)
